import communityboard from "../public/data/divisions/communityboard.json";
import neighborhood from "../public/data/divisions/neighborhood.json";
import congressional from "../public/data/divisions/congressional.json";

// Admin-division overlays players can toggle on to deduce Matching answers
// themselves (then slice manually). Each region is graph-colored (a `ci` index
// in its properties) so adjacent regions get different palette colors — making
// the boundaries obvious. Boundaries + labels only; no auto-elimination.
export interface Division {
  id: string;
  label: string;
  data: GeoJSON.FeatureCollection;
}

// Distinct alternating colors (indexed by feature `ci`).
export const DIV_PALETTE = ["#4363d8", "#3cb44b", "#e6194b", "#f58231", "#911eb4", "#00a3a3"];

export const DIVISIONS: Division[] = [
  { id: "congressional", label: "Congressional", data: congressional as GeoJSON.FeatureCollection },
  { id: "communityboard", label: "Community boards", data: communityboard as GeoJSON.FeatureCollection },
  { id: "neighborhood", label: "Neighborhoods", data: neighborhood as GeoJSON.FeatureCollection },
];
